import { Star } from "lucide-react"
import { cn } from "@/lib/utils"
import { STATUS_LABEL, type TranslationStatus } from "../../languages"

// One colour per status, used everywhere a translation's state is shown
export const STATUS_TONE: Record<TranslationStatus, string> = {
  source: "text-amber-500",
  missing: "bg-rose-500",
  unreviewed: "bg-amber-500",
  reviewed: "bg-emerald-500",
  translated: "bg-emerald-500",
}

export function StatusDot({ status, title, className }: { status: TranslationStatus; title?: string; className?: string }) {
  if (status === "source") {
    return <Star className={cn("h-3 w-3 shrink-0 fill-current", STATUS_TONE.source, className)} aria-label={title ?? "Source language"} />
  }
  return (
    <span
      role="img"
      aria-label={title ?? STATUS_LABEL[status]}
      title={title ?? STATUS_LABEL[status]}
      className={cn("inline-block h-2 w-2 shrink-0 rounded-full", STATUS_TONE[status], className)}
    />
  )
}

// What the dots mean, for panels that show many of them
export function StatusLegend({ className }: { className?: string }) {
  const shown: TranslationStatus[] = ["source", "reviewed", "unreviewed", "missing"]
  return (
    <div className={cn("flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-muted-foreground", className)}>
      {shown.map(s => (
        <span key={s} className="flex items-center gap-1.5">
          <StatusDot status={s} />
          {STATUS_LABEL[s]}
        </span>
      ))}
    </div>
  )
}
